import { Injectable } from "@angular/core";

export interface PromotionImages {
  contadoMP: string; // Contado Muebleria El Pasito (Chihuahua)
  contadoVM: string; // Contado Villarreal Muebles
  contadoVEG: string; // Contado Villarreal Ekkar de Gas
  creditoMP: string; // Crédito Muebleria El Pasito
  creditoVM: string; // Crédito Villarreal Muebles
  creditoVEG: string; // Crédito Villarreal Ekkar de Gas
  apartado50: string; // Banner de apartado $50
  apartado40: string; // Banner de apartado 40%
  motos: string; // Banner especial de motos
  motosVM: string; // Banner motos Villarreal Muebles
  motosVEG: string; // Banner motos Villarreal Ekkar de Gas
  envios: string; // Banner de envíos
  logo: string;        // Logo de la promoción (overlay sobre productos)
  mainHeader: string;  // Banner superior de la página
  mainFooter: string;  // Banner inferior de la página
  footerCredit: string; // Banner pie de sección crédito
  qrMP?: string;    // QR Mueblería El Pasito
  qrVM?: string;    // QR Villarreal Muebles
  qrVEG?: string;   // QR Villarreal Ekar de Gas
  qrMotos?: string; // QR Villarreal Motos (sucursales de Villarreal Motos)
}

/**
 * Servicio para gestionar las imágenes de promociones de forma dinámica.
 *
 * Permite configurar las imágenes de cada promoción sin necesidad de modificar
 * el código del componente. Solo se necesita agregar una nueva entrada en el
 * mapa de configuración.
 */
@Injectable({
  providedIn: "root",
})
export class PromotionImagesService {
  /**
   * Imágenes por defecto cuando no hay promoción activa
   */
  private defaultImages: PromotionImages = {
    contadoMP: "assets/img/banner_contado.png",
    contadoVM: "assets/img/banner_contado.png",
    contadoVEG: "assets/img/banner_contado.png",
    creditoMP: "assets/img/banner_credito_01.png",
    creditoVM: "assets/img/banner_credito_02.png",
    creditoVEG: "assets/img/banner_credito_03.png",
    apartado50: "assets/img/banner_contado_01.jpg", // Fallback
    apartado40: "assets/img/banner_contado_02.jpg", // Fallback
    motos: "assets/img/banner_credito_01.jpg",
    motosVM: "assets/img/banner_credito_02.jpg",
    motosVEG: "assets/img/banner_credito_03.png",
    envios: "assets/img/footer_credit.jpg",
    logo: "",
    mainHeader: "assets/img/main_header.png",
    mainFooter: "assets/img/main_footer.png",
    footerCredit: "assets/img/footer_credit.jpg",
  };

  /**
   * Configuración de imágenes por promoción.
   *
   * Para agregar una nueva promoción:
   * 1. Agregar carpeta en assets/ con las imágenes
   * 2. Agregar entrada aquí con el nombre exacto de la promoción del backend
   */
  private promotionImagesMap: { [promotionName: string]: PromotionImages } = {
    "Hot Sale": {
      contadoMP: "assets/hotsale/Banner_leaderboard_1440_x_400_Contado@2x.png",
      contadoVM: "assets/hotsale/Banner_leaderboard_1440_x_400_Contado@2x.png",
      contadoVEG: "assets/hotsale/Banner_leaderboard_1440_x_400_Contado@2x.png",
      creditoMP: "assets/hotsale/Banner_leaderboard_1440_x_400_Pasito@2x.png",
      creditoVM: "assets/hotsale/Banner_leaderboard_1440_x_400_VR@2x.png",
      creditoVEG: "assets/hotsale/Banner_leaderboard_1440_x_400_VEG@2x.png",
      apartado50: "assets/hotsale/Banner_leaderboard_1440_x_400_Apartado@2x.png",
      apartado40: "assets/hotsale/Banner_leaderboard_1440_x_400_Apartado@2x.png",
      motos: "assets/hotsale/Banner_leaderboard_1440_x_400_Motos@2x.png",
      motosVM: "assets/hotsale/Banner_leaderboard_1440_x_400_Motos@2x.png",
      motosVEG: "assets/hotsale/Banner_leaderboard_1440_x_400_Motos@2x.png",
      envios: "assets/hotsale/Banner_Full_width_1440_x_237_24hrs@2x.png",
      logo: "assets/hotsale/hotsale_logo.png",
      mainHeader: "assets/hotsale/Header_1440x400@2x.png",
      mainFooter: "assets/hotsale/Footers_1440x400@2x.png",
      footerCredit: "assets/hotsale/Banner_Full_width_1440_x_237@2x.png",
    },
    "Feria del hogar": {
      contadoMP: "assets/fdh/40porciento_566.png",
      contadoVM: "assets/fdh/40porciento_566.png",
      contadoVEG: "assets/fdh/40porciento_566.png",
      creditoMP: "assets/fdh/descuento_566[1].png",
      creditoVM: "assets/fdh/desceunto_566.png",
      creditoVEG: "assets/fdh/desceunto_566.png",
      apartado50: "assets/fdh/50pesito_566.png",
      apartado40: "assets/fdh/50pesito_566[1].png",
      motos: "assets/fdh/motos_566[2].png",
      motosVM: "assets/fdh/motos_566.png",
      motosVEG: "assets/fdh/motos_566.png",
      envios: "assets/hotsale/webp2025/banner_web_hs_25_envios.webp",
      logo: "",
      mainHeader: "assets/img/main_header.png",
      mainFooter: "assets/img/main_footer.jpg",
      footerCredit: "assets/img/footer_credit.jpg",
    },
    "Buen Fin": { //ACTUALIZACIÓN 2026:
      contadoMP: "assets/bf/Banner_Web_BuenFin_Landing_26__Congela_HS.jpg",
      contadoVM: "assets/bf/Banner_Web_BuenFin_Landing_26__Congela_HS.jpg",
      contadoVEG: "assets/bf/Banner_Web_BuenFin_Landing_26__Congela_HS.jpg",
      creditoMP: "assets/bf/Banner_Web_BuenFin_Landing_26__Cupon_Mil_Credito_.jpg",
      creditoVM: "assets/bf/Banner_Web_BuenFin_Landing_26__Cupon_Mil_Credito_.jpg",
      creditoVEG: "assets/bf/Banner_Web_BuenFin_Landing_26__Cupon_Mil_Credito_.jpg",
      apartado50: "assets/bf/Banner_Web_BuenFin_Landing_26__Congela_50_HS.jpg",
      apartado40: "assets/bf/Banner_Web_BuenFin_Landing_26__Congela_HS.jpg",
      motos: "assets/bf/Banner_Web_BuenFin_Landing_26__Cupon_Mil_Motos.jpg",
      motosVM: "assets/bf/Banner_Web_BuenFin_Landing_26__Cupon_Mil_Motos.jpg",
      motosVEG: "assets/bf/Banner_Web_BuenFin_Landing_26__Cupon_Mil_Motos.jpg",
      envios: "assets/bf/Banner_Web_BuenFin_Landing_26__Envios_HS.jpg",
      logo: "assets/pcm/casita_logo.png", //decisión de arriba que sea el logo de la casita en vez de bf
      mainHeader: "assets/img/main_header.png",
      mainFooter: "assets/img/main_footer.png",
      footerCredit: "assets/img/footer_credit.jpg",
      qrMP: "assets/bf/qr_bf_pasito.png",
      qrVM: "assets/bf/qr_bf_villarreal.png",
      qrVEG: "assets/bf/qr_bf_ekar_gas.png",
      qrMotos: "assets/bf/qr_bf_motos.png",
    },
    "35 Aniversario": {
      contadoMP: "assets/aniversario/Banner_Web_35_Aniv_Landing__Congela_HS.jpg",
      contadoVM: "assets/aniversario/Banner_Web_35_Aniv_Landing__Congela_HS.jpg",
      contadoVEG: "assets/aniversario/Banner_Web_35_Aniv_Landing__Congela_HS.jpg",
      creditoMP: "assets/aniversario/Banner_Web_35_Aniv_Landing__Cupon_Mil_Credito_.jpg",
      creditoVM: "assets/aniversario/Banner_Web_35_Aniv_Landing__Cupon_Mil_Credito_.jpg",
      creditoVEG: "assets/aniversario/Banner_Web_35_Aniv_Landing__Cupon_Mil_Credito_.jpg",
      apartado50: "assets/aniversario/Banner_Web_35_Aniv_Landing__Congela_50_HS.jpg",
      apartado40: "assets/aniversario/Banner_Web_35_Aniv_Landing__Congela_HS.jpg",
      motos: "assets/aniversario/Banner_Web_35_Aniv_Landing__Cupon_Mil_Motos.jpg",
      motosVM: "assets/aniversario/Banner_Web_35_Aniv_Landing__Cupon_Mil_Motos.jpg",
      motosVEG: "assets/aniversario/Banner_Web_35_Aniv_Landing__Cupon_Mil_Motos.jpg",
      envios: "assets/aniversario/Banner_Web_35_Aniv_Landing__Envios_HS.jpg",
      logo: "assets/pcm/casita_logo.png",
      mainHeader: "assets/img/main_header.png",
      mainFooter: "assets/img/main_footer.png",
      footerCredit: "assets/img/footer_credit.jpg",
    },
    "Promo Dia Madres": {
      contadoMP: "assets/pcm/Banner_leaderboard_1440_x_400_Contado@2x.png",
      contadoVM: "assets/pcm/Banner_leaderboard_1440_x_400_VR@2x.png",
      contadoVEG: "assets/pcm/Banner_leaderboard_1440_x_400_VR@2x.png",
      creditoMP: "assets/pcm/Banner_leaderboard_1440_x_400_Pasito@2x.png",
      creditoVM: "assets/pcm/Banner_leaderboard_1440_x_400_VR@2x.png",
      creditoVEG: "assets/pcm/Banner_leaderboard_1440_x_400_VR@2x.png",
      apartado50: "assets/pcm/Banner_leaderboard_1440_x_400_Apartado@2x.png",
      apartado40: "assets/pcm/Banner_leaderboard_1440_x_400_Apartado@2x.png",
      motos: "assets/pcm/Banner_leaderboard_1440_x_400_Motos@2x.png",
      motosVM: "assets/pcm/Banner_leaderboard_1440_x_400_Motos@2x.png",
      motosVEG: "assets/pcm/Banner_leaderboard_1440_x_400_Motos@2x.png",
      envios: "assets/pcm/Banner_Full_width_1440_x_237_24hrs@2x.png",
      logo: "assets/pcm/casita_logo.png",
      mainHeader: "assets/pcm/Header_1440x400@2x.png",
      mainFooter: "assets/pcm/Footers_1440x400@2x.png",
      footerCredit: "assets/pcm/Banner_Full_width_1440_x_237@2x.png",
    },
  };

  constructor() {}

  /**
   * Obtiene las imágenes correspondientes a una promoción.
   * Si no se encuentra la promoción, devuelve las imágenes por defecto.
   *
   * @param promotionName Nombre de la promoción (debe coincidir con el backend)
   * @returns Objeto con todas las rutas de imágenes
   */
  getPromotionImages(promotionName: string | null): PromotionImages {
    if (!promotionName) {
      return this.defaultImages;
    }

    // Normalizar el nombre de la promoción (quitar el rango de fechas)
    const normalizedName = this.normalizePromotionName(promotionName);

    const images = this.promotionImagesMap[normalizedName];

    if (!images) {
      console.warn(
        `No se encontraron imágenes para la promoción: "${normalizedName}". Usando imágenes por defecto.`,
      );
      return this.defaultImages;
    }

    return images;
  }

  /**
   * Nombre normalizado de la promoción (p. ej. "Buen Fin del: 13 al 17..." -> "Buen Fin")
   */
  getPromotionKey(promotionName: string | null): string {
    return promotionName ? this.normalizePromotionName(promotionName) : "";
  }

  private normalizePromotionName(promotionName: string): string {
    const knownPromotions = Object.keys(this.promotionImagesMap);
    const lowerName = promotionName.toLowerCase();
    for (const key of knownPromotions) {
      if (lowerName.includes(key.toLowerCase())) {
        return key;
      }
    }
    return promotionName.trim();
  }

  /**
   * Obtiene una imagen específica según el tipo y la zona.
   *
   * @param imageType Tipo de imagen (contado, credito, apartado, motos, envios)
   * @param zone Zona geográfica (CHIHUAHUA o Villarreal Muebles)
   * @param promotionName Nombre de la promoción activa
   * @param hasApartado Si tiene apartado (para seleccionar banner correcto)
   * @returns Ruta de la imagen
   */
  // Marca por cedis: 1 = Mueblería El Pasito, 13 = Villarreal Ekar de Gas, resto = Villarreal Muebles
  private getBusinessType(zone: string, zoneId: number): 'MP' | 'VM' | 'VEG' {
    if (zoneId === 1) return 'MP';
    if (zoneId === 13) return 'VEG';
    return 'VM';
  }

  /**
   * Sucursal de Villarreal Motos. Por ahora se detecta por nombre de sucursal;
   * en ERP_CIE.dbo.sucursales corresponde a Tipo_ubicacion = 'Sucursal Villarreal Motos'.
   */
  private esSucursalMotos(branch: string | null): boolean {
    return (branch || "").toLowerCase().includes("villarreal motos");
  }

  /**
   * QR de la promoción según la marca: Villarreal Motos por sucursal, el resto por cedis.
   * Si la promoción no tiene QR por marca, regresa el QR genérico de Buen Fin.
   */
  getPromotionQr(zoneId: number, branch: string | null, promotionName: string | null): string {
    const images = this.getPromotionImages(promotionName);
    if (this.esSucursalMotos(branch) && images.qrMotos) {
      return images.qrMotos;
    }
    const businessType = this.getBusinessType("", zoneId);
    const qr = businessType === 'MP'
      ? images.qrMP
      : businessType === 'VEG'
        ? images.qrVEG
        : images.qrVM;
    return qr || "assets/bf/qrbuenfin.svg";
  }

  getImage(
    imageType: "contado" | "credito" | "apartado" | "motos" | "envios" | "mainHeader" | "mainFooter" | "footerCredit",
    zone: string,
    zoneId: number,
    promotionName: string | null,
    hasApartado: boolean = false,
  ): string {
    const images = this.getPromotionImages(promotionName);
    const businessType = this.getBusinessType(zone, zoneId);

    switch (imageType) {
      case "contado":
        if (businessType === 'MP') return images.contadoMP;
        if (businessType === 'VEG') return images.contadoVEG;
        return images.contadoVM;

      case "credito":
        if (businessType === 'MP') return images.creditoMP;
        if (businessType === 'VEG') return images.creditoVEG;
        return images.creditoVM;

      case "apartado":
        return hasApartado ? images.apartado50 : images.apartado40;

      case "motos":
        if (businessType === 'MP') return images.motos;
        if (businessType === 'VEG') return images.motosVEG;
        return images.motosVM;

      case "envios":
        return images.envios;

      case "mainHeader":
        return images.mainHeader;

      case "mainFooter":
        return images.mainFooter;

      case "footerCredit":
        return images.footerCredit;

      default:
        return this.defaultImages.contadoMP;
    }
  }

  /**
   * Verifica si hay promoción activa
   */
  hasActivePromotion(promotionName: string | null): boolean {
    return promotionName !== null && promotionName !== "";
  }

  /**
   * Obtiene el logo de la promoción activa.
   * Retorna string vacío si no hay logo o no hay promoción.
   *
   * @param promotionName Nombre de la promoción activa
   * @returns Ruta del logo o string vacío
   */
  getPromotionLogo(promotionName: string | null): string {
    if (!promotionName) {
      return "";
    }

    const images = this.getPromotionImages(promotionName);
    return images.logo;
  }
}
